import { AddressBook, Phone, MapPin } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'
import useKioskAutoHome from '../../hooks/useKioskAutoHome'
import { useLang } from '../../context/LangContext'

const CONTENT = {
  en: {
    pageTitle: 'Contact Directory',
    pageSubtitle: 'Building and community contacts',

    title: 'Contact Directory',
    subtitle:
      'Find important contacts for assistance and building support.',

    contacts: [
      {
        name: 'Management Office',
        phone: '+60 82 000 001',
        location: 'Level G, Admin Office',
      },
      {
        name: 'Security Counter',
        phone: '+60 82 000 002',
        location: 'Main Lobby',
      },
      {
        name: 'Facilities Team',
        phone: '+60 82 000 003',
        location: 'Maintenance Office',
      },
      {
        name: 'Emergency Contact',
        phone: '999',
        location: 'For emergency use only',
      },
    ],
  },

  bm: {
    pageTitle: 'Direktori Kontak',
    pageSubtitle: 'Kontak bangunan dan komuniti',

    title: 'Direktori Kontak',
    subtitle:
      'Cari kontak penting untuk bantuan dan sokongan bangunan.',

    contacts: [
      {
        name: 'Pejabat Pengurusan',
        phone: '+60 82 000 001',
        location: 'Aras G, Pejabat Pentadbiran',
      },
      {
        name: 'Kaunter Keselamatan',
        phone: '+60 82 000 002',
        location: 'Lobi Utama',
      },
      {
        name: 'Pasukan Fasiliti',
        phone: '+60 82 000 003',
        location: 'Pejabat Penyelenggaraan',
      },
      {
        name: 'Kontak Kecemasan',
        phone: '999',
        location: 'Untuk kegunaan kecemasan sahaja',
      },
    ],
  },
}

export default function DirectoryPage() {
  useKioskAutoHome()

  const { lang } = useLang()

  const t = CONTENT[lang] || CONTENT.en

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader
          title={t.pageTitle}
          subtitle={t.pageSubtitle}
        />

        <section className="kiosk-section-card">
          <div className="kiosk-section-card__header">
            <AddressBook size={30} />

            <div>
              <h1>{t.title}</h1>
              <p>{t.subtitle}</p>
            </div>
          </div>

          <div className="kiosk-list">
            {t.contacts.map((contact) => (
              <article
                className="kiosk-list-card"
                key={contact.name}
              >
                <strong>{contact.name}</strong>

                <div>
                  <Phone size={18} />
                  {contact.phone}
                </div>

                <div>
                  <MapPin size={18} />
                  {contact.location}
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  )
}